export const fieldWidthMap = {
	100: "flex-none basis-full",
	75: "flex-none basis-full md:basis-[calc(75%_-_(var(--form-gap-x)_*_0.25))]",
	66: "flex-none basis-full md:basis-[calc(66.6667%_-_(var(--form-gap-x)_*_0.333333))]",
	50: "flex-none basis-full md:basis-[calc(50%_-_(var(--form-gap-x)_/_2))]",
	33: "flex-none basis-full md:basis-[calc(33.3333%_-_(var(--form-gap-x)_*_0.666667))]",
	25: "flex-none basis-full md:basis-[calc(25%_-_(var(--form-gap-x)_*_0.75))]",
} as const;

export function filterBlockWidthClass(width: string | number | null | undefined): (typeof fieldWidthMap)[keyof typeof fieldWidthMap] {
	return fieldWidthMap[(Number(width) || 100) as keyof typeof fieldWidthMap] ?? fieldWidthMap[100];
}
